/**
 * @desc 导出供应商账号信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierAccountMaster.exportSupplierAccountMaster.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/exportSupplierAccountMaster`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
